module.exports = __webpack_public_path__ + "img/artnhealing_thumb_01.7232567f.jpg";